import Backbone from 'backbone';
import ko from 'knockout';
import _ from 'underscore';
import config from '@bingads-webui-component-legacy/config/index';
import ViewModel from '@bingads-webui-campaign-legacy/crud-ad/viewmodel/adsEditor/dynamicSearchAd';
import editorTemplate from '@bingads-webui-campaign-legacy/crud-ad/template/adsEditor/dynamicSearchAd.pug';
import buildPreview from '@bingads-webui-campaign-legacy/crud-ad/view/adsPreview/dynamicSearchAd';
import { isCampaignApiError } from '@bingads-webui-component-legacy/api-errors-campaign/index';
import UrlOptions from '@bingads-webui-component-legacy/upgraded-url/view/advancedSettingsUrlOptions';
import uuid from '@bingads-webui-component-legacy/uuid/index';
import { enableAdCustomizersHelpers } from './adCustomizersHelpers';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

const permissions = config.get('Permissions') || {};

const nameAttrs = {
  'Text': 'Ad.ExpandedTextAd.AdDescription',
  'TextPart2': 'Ad.ExpandedTextAd.AdDescription2',
  'Path1': 'Ad.ExpandedTextAd.Path1',
  'Path2': 'Ad.ExpandedTextAd.Path2',
};

const fieldsWithLabel = ['Path1', 'Path2'];
const labels = _.object(fieldsWithLabel, _.map(fieldsWithLabel, (field) => {
  return i18n.get(`DynamicSearchAd_Label_${field}`);
}));

export default class DynamicSearchAdEditor extends Backbone.View {
  initialize({
    model = null,
    isForVNext = false,
    showAdType = false,
    isTraditionalChinese = false,
    scope = null,
    activityLogger,
  } = {}) {
    this.showAdType = showAdType;
    this.isForVNext = isForVNext;
    this.useUpgradedUrl = true;
    this.activityLogger = activityLogger;
    this.viewModel = new ViewModel({
      model,
      useUpgradedUrl: this.useUpgradedUrl,
      isTraditionalChinese,
      scope,
      activityLogger,
    });
  }

  render() {
    this.$el.html(editorTemplate({
      i18n,
      uuid,
      useUpgradedUrl: this.useUpgradedUrl,
      labels,
      placeholders: {},
      showAdType: this.showAdType,
      nameAttrs,
      allowDisclaimerAds: true,
    }));

    ko.applyBindings(this.viewModel, this.el);

    if (this.useUpgradedUrl) {
      if (_.isObject(this.model)) {
        this.urlOptions = new UrlOptions({
          editMode: true,
          smallContainer: true,
          trackingTemplate: _.result(this.model, 'TrackingUrlTemplate'),
          finalUrlSuffix: _.result(this.model, 'FinalUrlSuffix'),
          customParameters: _.isEmpty(this.model.UrlCustomParameters) ? undefined : _.clone(this.model.UrlCustomParameters), // eslint-disable-line
          entityType: 'Ad',
          activityLogger: this.activityLogger,
        }).render();
      } else {
        this.urlOptions = new UrlOptions({
          smallContainer: true,
          entityType: 'Ad',
          activityLogger: this.activityLogger,
        }).render();
      }
      this.$el.find('.advanced-options').html(this.urlOptions.$el);
    }

    this.previewContainer = buildPreview(this.viewModel, {});
    this.$('.preview-container').empty().append(this.previewContainer.render().el);

    this.enableAdCustomizersHelpersForDSA();
    return this;
  }

  validateViewModel() {
    const isValid = this.viewModel.validate();

    if (!isValid) {
      _.each(this.viewModel.fields, (field) => {
        if (!this.viewModel[field].isValid()) {
          if (this.activityLogger) {
            this.activityLogger.signal(`ad field invalid: ${field}`, 'dynamic search ad editor');
          }
        }
      });
    }
    return isValid;
  }

  validate() {
    return this.validateViewModel() && (!this.useUpgradedUrl || this.urlOptions.isValid());
  }

  toObject() {
    const model = this.viewModel.toObject();

    if (!this.useUpgradedUrl) {
      return model;
    }

    return _.extend(_.omit(model, this.viewModel.upgradedUrlFields), {
      TrackingUrlTemplate: this.urlOptions.getTrackingTemplate(),
      UrlCustomParameters: this.urlOptions.getUrlCustomParameters(true),
      FinalUrlSuffix: this.urlOptions.getFinalUrlSuffix(),
    });
  }

  handleApiErrors(errors) {
    this.viewModel.errors.add(errors);

    if (this.useUpgradedUrl) {
      let errorObject = _.object(this.viewModel.upgradedUrlFields, _.map(this.viewModel.upgradedUrlFields, (key) => {
        return _.result(this.viewModel[key], 'errors', []);
      }));

      this.urlOptions.handleApiErrors(errorObject);
    }
  }

  clearApiErrors() {
    this.viewModel.errors.clear(isCampaignApiError);
    if (this.useUpgradedUrl) {
      this.urlOptions.clearApiErrors();
    }
  }

  enableAdCustomizersHelpersForDSA() {
    const customizableFields = [
      'Text',
      ...permissions.IsExpandedDsaPhase2Enabled ? ['TextPart2'] : [], 'Path1', 'Path2'];

    enableAdCustomizersHelpers(this, customizableFields, nameAttrs, 'DynamicSearchAd');
  }
}
